import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({ show, title, message, onConfirm, onCancel, confirmText, cancelText }) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                {cancelText && onCancel && (
                    <Button variant="secondary" onClick={onCancel}>
                        {cancelText}
                    </Button>
                )}
                {confirmText && onConfirm && (
                    <Button variant="danger" onClick={onConfirm}>
                        {confirmText}
                    </Button>
                )}
                {/* This is for the error case where there is no confirm action */}
                {confirmText && !onConfirm && (
                    <Button variant="primary" onClick={onCancel}>
                        {confirmText}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
